import React, { useEffect, useState } from "react";
import FormComponent from "../../../../../components/gernerateForm/FormComponent";
import generateForm05 from "../data/form05.data";

type Props = {
  onSubmit: (value: any) => void;
  isValidateForm: boolean;
  data: any;
  setData: (value: any) => void;
  mainInputValue: any;
  isValudateFile: boolean;
  isCanEdit?: boolean | true;
};
const Form05: React.FC<Props> = (props: Props) => {
  const {
    onSubmit,
    isValidateForm,
    data,
    setData,
    mainInputValue,
    isValudateFile,
    isCanEdit,
  } = props;

  const [inputValueFormLeave05, setInputValueFormLeave05] = useState({
    information: {
      salary_amount: 0,
      wish: "",
      place: "",
    },
    peroid_to_work: {
      year_amount: 0,
      month_amount: 0,
      day_amount: 0,
      reason: "",
      knowledge_foreign_languages: "",
      institution_studied_foreign_languages: "",
      year_amount_studied: "",
      will_go: "",
      benefits_trip: "",
    },
  });


  useEffect(() => {
    const information = mainInputValue.information;
    const condition = inputValueFormLeave05.information;
    const peroid_to_work = inputValueFormLeave05.peroid_to_work;

    setData({
      main: information,
      condition: condition,
      peroid_to_work: peroid_to_work,
    });
  }, [inputValueFormLeave05]);

  useEffect(() => {
    if (data?.condition) {
      setInputValueFormLeave05({
        information: data.condition,
        peroid_to_work: data.peroid_to_work,
      });
    }
  }, []);

  return (
    <FormComponent
      formGenerate={generateForm05}
      inputValue={inputValueFormLeave05}
      setInputValue={setInputValueFormLeave05}
      handleCheckValid={isValidateForm}
      isCanEdit={isCanEdit ?? true}
      permission={"admin"}
    />
  );
};

export default Form05;
